import { render, staticRenderFns } from "./DataSyncNotification.vue?vue&type=template&id=40b25393&"
import script from "./DataSyncNotification.vue?vue&type=script&lang=js&"
export * from "./DataSyncNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports